import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import automationService from '../../../services/automationService';

const DeleteCampaign = ({ campaignId, workflowId, campaignType, onClose }) => {
  const navigate = useNavigate();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  const handleDeleteCampaign = async _ => {
    try {
      setLoading(true);
      let res;
      if (campaignType === 'linkedin' && workflowId) {
        res = await automationService.deleteWorkflow(workflowId);
      } else {
        res = await campaignService.deleteCampaign(campaignId);
      }
      if (res?.success) {
        Toast({ type: 'success', message: res?.message || 'Campaign deleted successfully' });
        setConfirmDelete(true);
      }
    } catch (error) {
      Toast({ type: 'error', message: error?.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Campaign!"
          description="Are you sure you want to delete this campaign? This action cannot be undone."
          btns={
            <>
              <Button onClick={() => onClose()}>Cancel</Button>
              <Button variant="danger" onClick={() => handleDeleteCampaign()} loader={loading} disabled={loading}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Campaign Deleted Successfully!"
          btns={
            <Button
              onClick={() => {
                onClose();
                refetch();
              }}>
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DeleteCampaign;
